import React, { Component } from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import "../AFSTool/afs-walkthrough.css";

const STATUS_LOOKS = {
	fail: { icon: Icon.XCircle, color: "#c62828" },
	warn: { icon: Icon.AlertCircle, color: "#e67e22" },
	info: { icon: Icon.Info, color: "#1565c0" },
	pass: { icon: Icon.CheckCircle, color: "#2e7d32" },
	blocked: { icon: Icon.Lock, color: "#b8860b" },
	na: { icon: Icon.MinusCircle, color: "#9e9e9e" },
};

class ToolsReviewItem extends Component {
	render() {
		const { id, status, detailTone, label, detail, children, after } = this.props;
		const look = STATUS_LOOKS[status] || STATUS_LOOKS.warn;
		const StatusIcon = look.icon;
		const isNotApplicable = status === "na";
		const tone = detailTone || status;

		return (
			<div id={id} className={clsx("afs-review__item", `afs-review__item--${status}`)}>
				<StatusIcon size={18} color={look.color} className="afs-review__icon" />
				<div className="afs-review__content">
					<p className={clsx("afs-review__label", isNotApplicable && "afs-review__label--na")}>{label}</p>
					{detail && (
						<p
							className={clsx(
								"afs-review__detail",
								tone === "pass" && "afs-review__detail--pass",
								tone === "fail" && "afs-review__detail--fail",
								isNotApplicable && "afs-review__detail--na"
							)}
						>
							{detail}
						</p>
					)}
					{children}
				</div>
				{after}
			</div>
		);
	}
}

class ToolsReviewResolution extends Component {
	render() {
		const { text, kindLabel, actions, children } = this.props;
		return (
			<div className="afs-review__resolution">
				<div className="afs-review__resolution-header">
					<span className="afs-review__resolution-label">Resolution:</span>
					<span className="afs-review__resolution-text">{text}</span>
					{kindLabel && <span className="afs-review__resolution-type">{kindLabel}</span>}
					{actions}
				</div>
				{children}
			</div>
		);
	}
}

class ToolsReviewTools extends Component {
	render() {
		const { tools } = this.props;
		return (
			<div className="afs-review__item-tools">
				{tools.map(tool => (
					<button
						key={tool.key}
						type="button"
						className={clsx("afs-review__item-tool-btn", tool.isActive && "afs-review__item-tool-btn--active")}
						title={tool.title}
						aria-label={tool.title}
						onClick={tool.onClick}
					>
						{tool.icon}
					</button>
				))}
			</div>
		);
	}
}

export { ToolsReviewResolution, ToolsReviewTools };
export default ToolsReviewItem;
